const l = "_thumbnail_1l2sr_1", i = "_disabled_1l2sr_135", a = {
  "thumbnail--size-small-icon": "_thumbnail--size-small-icon_1l2sr_1",
  "thumbnail--background": "_thumbnail--background_1l2sr_4",
  "thumbnail--size-medium-icon": "_thumbnail--size-medium-icon_1l2sr_13",
  "thumbnail--size-large-icon": "_thumbnail--size-large-icon_1l2sr_25",
  "thumbnail--size-extra-large-icon": "_thumbnail--size-extra-large-icon_1l2sr_37",
  "thumbnail--size-small-logo": "_thumbnail--size-small-logo_1l2sr_49",
  "thumbnail--size-medium-logo": "_thumbnail--size-medium-logo_1l2sr_58",
  "thumbnail--size-large-logo": "_thumbnail--size-large-logo_1l2sr_66",
  "thumbnail--size-extra-large-logo": "_thumbnail--size-extra-large-logo_1l2sr_74",
  thumbnail: l,
  "thumbnail--image": "_thumbnail--image_1l2sr_107",
  "thumbnail--size-small": "_thumbnail--size-small_1l2sr_1",
  "thumbnail--size-medium": "_thumbnail--size-medium_1l2sr_13",
  "thumbnail--size-large": "_thumbnail--size-large_1l2sr_25",
  "thumbnail--size-extra-large": "_thumbnail--size-extra-large_1l2sr_37",
  disabled: i
};
export {
  a as default,
  i as disabled,
  l as thumbnail
};
//# sourceMappingURL=index.es679.js.map
